<!-- Status Banner -->
<!-- TODO: duplicate alert: need to test -->
<!-- <app-alert
  [alertService]="harpStatusAlertService"
  [dismissible]="false"
></app-alert> -->

<h1 class="harp-card-title harp-login-title">Login</h1>

<p>
  Enter your HARP, EIDM, or EUA credentials to log into
  {{ currentApp?.pageTitle ?? 'HARP' }}.
</p>

<form class="login-save-form" #loginInformationForm="ngForm">
  <!-- User Id Input-->
  <harp-input [inputConfig]="userIdConfig" [maskData]="true"></harp-input>

  <!-- Password Input -->
  <harp-input [inputConfig]="passwordConfig" [maskData]="true"></harp-input>

  <!-- Trouble Logging In Link-->
  <a
    class="harp-forgot-link"
    [routerLink]="['/login/account-recovery']"
    queryParamsHandling="merge"
    >Having trouble logging in?</a
  >

  <!-- Terms and Conditions-->
  <span class="visually-hidden"
    >The Terms and Conditions button opens a modal dialog. It may be necessary
    to initiate reading with the read continuously command for your screen
    reader.</span
  >
  <p class="mt-3 mb-4">
    By logging in, you agree to the
    <button type="button" class="link" (click)="openModal(termsAndConditions)">
      Terms & Conditions
    </button>
  </p>

  <!-- Login Button -->
  <button
    id="harp-login"
    class="btn btn-primary btn-lg d-block w-100 harp-login-button"
    (click)="userLoginCheck()"
  >
    Login
  </button>

  <div class="harp-divider"><span class="harp-divider-text">OR</span></div>

  <!-- PIV Card Login Button-->
  <button
    type="button"
    placement="top"
    ngbTooltip="CMS users must log into HARP using their EUA credentials at least once before the PIV card login feature is activated. If you are having trouble utilizing PIV to log in, please sign in using EUA first."
    class="btn btn-outline-primary btn-lg d-block w-100 harp-login-button"
    (click)="onPIVLinkSelection()"
  >
    CMS EUA PIV Card
  </button>

  <!-- Sign Up Button -->
  <p>
    Don't have an account?
    <button
      id="sign-up"
      type="button"
      class="link"
      (click)="this.navigationService.goToRegistrationPage()"
    >
      Sign Up
    </button>
  </p>

  <!-- What is HARP? -->
  <div *ngIf="currentApp?.hasHarpResources" class="harp-applications-link">
    <button
      type="button"
      class="btn btn-link link"
      (click)="openModal(whatIsHARP)"
    >
      Learn More About HARP
    </button>
  </div>
</form>

<!-- Terms and Conditions Modal -->
<ng-template #termsAndConditions let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modalTitle">Terms and Conditions</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d()"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      OMB No.0938-1236 |
      <a
        href="https://www.cms.gov/Regulations-and-Guidance/Legislation/PaperworkReductionActof1995/index"
        target="_blank"
        >Paperwork Reduction Act</a
      >
    </p>
    <p>
      Updated Departmental Standard Warning Banner for HHS Information Systems,
      Memo dated July 14, 2016
    </p>
    <p>
      This warning banner provides privacy and security notices consistent with
      applicable federal laws, directives, and other federal guidance for
      accessing this Government system, which includes (1) this computer
      network, (2) all computers connected to this network, and (3) all devices
      and storage media attached to this network or to a computer on this
      network. This information system is provided for Government-authorized use
      only.
    </p>
    <p>
      Unauthorized or improper use of this system is prohibited and may result
      in disciplinary action and/or civil and criminal penalties.
    </p>
    <p>
      Personal use of social media and networking sites on this system is
      limited as to not interfere with official work duties and is subject to
      monitoring.
    </p>
    <p>
      By using this system, you understand and consent to the following: The
      Government may monitor, record, and audit your usage, including usage of
      personal devices and email systems for official duties or to conduct HHS
      business. Therefore, you have no reasonable expectation of privacy
      regarding any communication or data transiting or stored on this system.
      At any time, and for any lawful Government purpose, the government may
      monitor, intercept, and search and seize any communication or data
      transiting or stored on this system.
    </p>
    <p>
      Any communication or data transiting or stored on this system may be
      disclosed or used for any lawful Government purpose.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="c()">Close</button>
  </div>
</ng-template>

<!-- HARP Applications Modal -->
<ng-template #whatIsHARP let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modalTitle">What is HARP?</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d()"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      HARP is CMS's secure identity management platform that provides
      streamlined access to various applications on CCSQ's QualityNet for
      healthcare providers, contractors, and stakeholders.
    </p>
    <p>
      HARP offers access to several Line of Business (LOB) applications (e.g.,
      EQRS, iQIES, QPP, etc.) as well as the full suite of QualityNet IT service
      applications.
    </p>
    <p>
      With features like Single Sign-On (SSO), access management, and
      centralized user profile management, HARP ensures secure and efficient
      role management.
    </p>
    <p>
      You can use your existing EUA or EIDM credentials to access HARP, or
      <a routerLink="/register/profile-info" target="_blank"
        >register for a new HARP account.</a
      >
    </p>

    <p>
      For more details, visit
      <a routerLink="/login/help" target="_blank">HARP Help.</a>
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="c()">Close</button>
  </div>
</ng-template>
